<template>
    <div class="form-check form-switch" :class="{[optional_class]: true, 'subscript': has_subscript === true}">
        <template v-if="has_subscript === true">
            <small :class="{
                'subscript-on': (this.modelValue === this.checked_value),
            }">
                {{ (this.modelValue === this.checked_value) ? 'ON' : 'OFF' }}
            </small>
        </template>
        <label class="form-check-label">
            <input
                type="checkbox"
                class="form-check-input fs-4"
                v-model="checked_option"
                @change="$emit('update:modelValue', this.checked_option)"
                :true-value="checked_value"
                :false-value="unchecked_value"
                :disabled="disabled"
            >
            {{ option_label }}
        </label>
    </div>
</template>

<script>
export default {
    name: 'FormCheckbox',
    props: {
        modelValue: {
        },
        option_key_true: { //ON の際のvalue値
            type: Number,
            default: 1
        },
        option_key_false: { //OFF の際のvalue値
            type: Number,
            default: 0
        },
        option_label: {
            type: String,
            default: 'label'
        },
        has_subscript: { //ON・OFF テキストの表示
            type: Boolean,
            default: true,
        },
        optional_class: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        as_boolean: { //真偽値をbindする場合
            type: Boolean,
            default: false,
        },

    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            checked_option: this.modelValue,
            checked_value: this.as_boolean ? true : this.$helper.number(this.option_key_true),
            unchecked_value: this.as_boolean ? false : this.$helper.number(this.option_key_false),
        }
    },
    watch: {
        modelValue() {
            this.checked_option = this.modelValue;
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .form-switch { padding-left: 0; position: relative;}
    .form-check small {position: absolute; top: 0.15rem; left: 1rem; font-size: .8rem; display: block; text-align: center; width: 2.3rem; pointer-events: none;}
    .form-switch .form-check-input { width: 2.3em; margin: 0 0.8rem 0 0;}
    .form-check small.subscript-on {color: #fff !important; left: 0;}
    .form-check-input:checked {background-color: #6c757d; border-color: #6c757d;}
</style>
